'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselSlider", {
    enumerable: true,
    get: function() {
        return CarouselSlider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselSlider = require("./useCarouselSlider");
const _renderCarouselSlider = require("./renderCarouselSlider");
const _useCarouselSliderStylesstyles = require("./useCarouselSliderStyles.styles");
const _CarouselSliderContext = require("./CarouselSliderContext");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselSlider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselSlider.useCarouselSlider_unstable)(props, ref);
    (0, _useCarouselSliderStylesstyles.useCarouselSliderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselSliderStyles_unstable')(state);
    const context = (0, _CarouselSliderContext.useCarouselSliderContextValues_unstable)(state);
    return (0, _renderCarouselSlider.renderCarouselSlider_unstable)(state, context);
});
CarouselSlider.displayName = 'CarouselSlider';
